<!-- src/pages/LandingPage.vue -->
<template>
  <div class="h-dvh flex items-center justify-center">
    <div class="text-center flex flex-col">
      <h1 class="text-[120px] font-bold mb-4 dark:text-dark-text">404</h1>
      <p class="text-2xl font-bold mb-4 dark:text-dark-text">
        Page Not Found
      </p>
      <button @click="joinRoom" class="bg-blue-500 text-white px-4 py-2 rounded">
        Create New
      </button>

    </div>
  </div>
</template>

<script>
import Header from "@/components/Header.vue";

export default {
  name: "LandingPage",
  components: {
    Header,
  },
  data() {
    return {
      roomCode: "",
    };
  },
  computed: {
    AppName() {
      return process?.env?.VUE_APP_NAME
    }
  },
  methods: {
    mounted() {
      // this.$router.push(`/room/222`);
    },
    joinRoom() {
      this.$router.push(`/`);
    },
  },
};
</script>
